import {createStore, applyMiddleware, combineReducers} from 'redux';
// @ts-ignore
import thunkPromiseMiddleware from '@yunying/redux-thunk-promise-middleware';
import {createActions, handleActions} from 'redux-actions';
// @ts-ignore
import model from '~/model/index';

const getAction = (action: any, name: any) =>
    createActions({
        [name]: action,
    });

const getReducer = (reducer: any, name: any) =>
    Object.keys(reducer || {}).reduce((reducers: any, key) => {
        reducers[`${name}/${key}`] = reducer[key];
        return reducers;
    }, {});

const reducers: any = {};
const add = (model: any) => {
    let {name, action, reducer, state} = model;

    action = getAction(action, name);
    reducer = getReducer(reducer, name);

    reducers[name] = handleActions(reducer, state);

    delete model.action;
    delete model.state;
    delete model.reducer;

    Object.assign(model, action[name]);
};

Object.keys(model).forEach(item => {
    add(model[item]);
});

const middlewares = [thunkPromiseMiddleware];

// if (process.env.NODE_ENV !== 'production') {
// middlewares.push(require('redux-logger').default);
// }

const store = createStore(combineReducers(reducers), applyMiddleware(...middlewares));

export default store;
